@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-499_594_546)
internal val Res.string.orgchart_save_draft: StringResource by lazy {
      StringResource("string:orgchart_save_draft", "orgchart_save_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57253, 47),
      ))
    }

@delegate:ResourceContentHash(-1_262_643_659)
internal val Res.string.orgchart_search_placeholder: StringResource by lazy {
      StringResource("string:orgchart_search_placeholder", "orgchart_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57331, 95),
      ))
    }

@delegate:ResourceContentHash(2_081_757_499)
internal val Res.string.orgchart_select_placeholder: StringResource by lazy {
      StringResource("string:orgchart_select_placeholder", "orgchart_select_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57427, 63),
      ))
    }

@delegate:ResourceContentHash(1_834_193_664)
internal val Res.string.orgchart_set_director: StringResource by lazy {
      StringResource("string:orgchart_set_director", "orgchart_set_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57491, 53),
      ))
    }

@delegate:ResourceContentHash(-860_477_980)
internal val Res.string.orgchart_set_responsible: StringResource by lazy {
      StringResource("string:orgchart_set_responsible", "orgchart_set_responsible", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57545, 60),
      ))
    }

@delegate:ResourceContentHash(-1_674_756_662)
internal val Res.string.orgchart_status_current: StringResource by lazy {
      StringResource("string:orgchart_status_current", "orgchart_status_current", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57606, 39),
      ))
    }

@delegate:ResourceContentHash(-1_466_765_808)
internal val Res.string.orgchart_status_draft: StringResource by lazy {
      StringResource("string:orgchart_status_draft", "orgchart_status_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57646, 41),
      ))
    }

@delegate:ResourceContentHash(1_521_863_949)
internal val Res.string.orgchart_status_legacy: StringResource by lazy {
      StringResource("string:orgchart_status_legacy", "orgchart_status_legacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57688, 38),
      ))
    }

@delegate:ResourceContentHash(1_829_324_725)
internal val Res.string.orgchart_subtitle_edited: StringResource by lazy {
      StringResource("string:orgchart_subtitle_edited", "orgchart_subtitle_edited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57727, 72),
      ))
    }

@delegate:ResourceContentHash(-1_900_031_123)
internal val Res.string.orgchart_subtitle_published: StringResource by lazy {
      StringResource("string:orgchart_subtitle_published", "orgchart_subtitle_published", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57800, 75),
      ))
    }

@delegate:ResourceContentHash(1_506_909_238)
internal val Res.string.orgchart_subtitle_valid: StringResource by lazy {
      StringResource("string:orgchart_subtitle_valid", "orgchart_subtitle_valid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57876, 75),
      ))
    }

@delegate:ResourceContentHash(1_444_662_062)
internal val Res.string.orgchart_supervisor_available: StringResource by lazy {
      StringResource("string:orgchart_supervisor_available", "orgchart_supervisor_available", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57952, 53),
      ))
    }

@delegate:ResourceContentHash(62_584_523)
internal val Res.string.orgchart_supervisor_col_name: StringResource by lazy {
      StringResource("string:orgchart_supervisor_col_name", "orgchart_supervisor_col_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58006, 44),
      ))
    }

@delegate:ResourceContentHash(-1_317_222_191)
internal val Res.string.orgchart_supervisor_col_role: StringResource by lazy {
      StringResource("string:orgchart_supervisor_col_role", "orgchart_supervisor_col_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58051, 44),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.orgchart_supervisor_edit: StringResource by lazy {
      StringResource("string:orgchart_supervisor_edit", "orgchart_supervisor_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58096, 40),
      ))
    }

@delegate:ResourceContentHash(-1_495_453_086)
internal val Res.string.orgchart_supervisor_empty: StringResource by lazy {
      StringResource("string:orgchart_supervisor_empty", "orgchart_supervisor_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58137, 73),
      ))
    }

@delegate:ResourceContentHash(-953_324_736)
internal val Res.string.orgchart_supervisor_error: StringResource by lazy {
      StringResource("string:orgchart_supervisor_error", "orgchart_supervisor_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58211, 93),
      ))
    }

@delegate:ResourceContentHash(1_017_588_765)
internal val Res.string.orgchart_supervisor_none: StringResource by lazy {
      StringResource("string:orgchart_supervisor_none", "orgchart_supervisor_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58305, 92),
      ))
    }

@delegate:ResourceContentHash(746_313_285)
internal val Res.string.orgchart_supervisor_remove: StringResource by lazy {
      StringResource("string:orgchart_supervisor_remove", "orgchart_supervisor_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58398, 58),
      ))
    }

@delegate:ResourceContentHash(-1_863_087_911)
internal val Res.string.orgchart_supervisor_saved: StringResource by lazy {
      StringResource("string:orgchart_supervisor_saved", "orgchart_supervisor_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58457, 77),
      ))
    }

@delegate:ResourceContentHash(-1_231_052_430)
internal val Res.string.orgchart_supervisor_search: StringResource by lazy {
      StringResource("string:orgchart_supervisor_search", "orgchart_supervisor_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58535, 58),
      ))
    }

@delegate:ResourceContentHash(-1_952_178_518)
internal val Res.string.orgchart_supervisor_selected: StringResource by lazy {
      StringResource("string:orgchart_supervisor_selected", "orgchart_supervisor_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58594, 52),
      ))
    }

@delegate:ResourceContentHash(-996_137_219)
internal val Res.string.orgchart_title: StringResource by lazy {
      StringResource("string:orgchart_title", "orgchart_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58647, 54),
      ))
    }

@delegate:ResourceContentHash(742_973_668)
internal val Res.string.orgchart_toast_draft_saved: StringResource by lazy {
      StringResource("string:orgchart_toast_draft_saved", "orgchart_toast_draft_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58702, 54),
      ))
    }

@delegate:ResourceContentHash(-2_096_501_699)
internal val Res.string.orgchart_toast_save_error: StringResource by lazy {
      StringResource("string:orgchart_toast_save_error", "orgchart_toast_save_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58757, 109),
      ))
    }

@delegate:ResourceContentHash(1_381_284_192)
internal val Res.string.orgchart_total_events: StringResource by lazy {
      StringResource("string:orgchart_total_events", "orgchart_total_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58867, 45),
      ))
    }

@delegate:ResourceContentHash(1_603_140_714)
internal val Res.string.orgchart_total_stores: StringResource by lazy {
      StringResource("string:orgchart_total_stores", "orgchart_total_stores", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58913, 41),
      ))
    }

@delegate:ResourceContentHash(-1_794_245_564)
internal val Res.string.orgchart_total_transported: StringResource by lazy {
      StringResource("string:orgchart_total_transported", "orgchart_total_transported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58955, 54),
      ))
    }

@delegate:ResourceContentHash(542_980_517)
internal val Res.string.orgchart_total_upr: StringResource by lazy {
      StringResource("string:orgchart_total_upr", "orgchart_total_upr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59010, 34),
      ))
    }

@delegate:ResourceContentHash(326_434_294)
internal val Res.string.orgchart_transfer_company: StringResource by lazy {
      StringResource("string:orgchart_transfer_company", "orgchart_transfer_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59045, 57),
      ))
    }

@delegate:ResourceContentHash(-1_746_604_553)
internal val Res.string.orgchart_transfer_manager: StringResource by lazy {
      StringResource("string:orgchart_transfer_manager", "orgchart_transfer_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59103, 57),
      ))
    }

@delegate:ResourceContentHash(611_765_132)
internal val Res.string.orgchart_transfer_support: StringResource by lazy {
      StringResource("string:orgchart_transfer_support", "orgchart_transfer_support", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59161, 125),
      ))
    }

@delegate:ResourceContentHash(1_225_320_951)
internal val Res.string.orgchart_transfer_to: StringResource by lazy {
      StringResource("string:orgchart_transfer_to", "orgchart_transfer_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59365, 48),
      ))
    }

@delegate:ResourceContentHash(-1_799_915_874)
internal val Res.string.orgchart_transfer_to_director: StringResource by lazy {
      StringResource("string:orgchart_transfer_to_director", "orgchart_transfer_to_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59287, 77),
      ))
    }

@delegate:ResourceContentHash(-104_099_891)
internal val Res.string.orgchart_unassigned_manager: StringResource by lazy {
      StringResource("string:orgchart_unassigned_manager", "orgchart_unassigned_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59414, 71),
      ))
    }

@delegate:ResourceContentHash(821_234_805)
internal val Res.string.orgchart_unlink_action: StringResource by lazy {
      StringResource("string:orgchart_unlink_action", "orgchart_unlink_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59486, 46),
      ))
    }

@delegate:ResourceContentHash(814_893_812)
internal val Res.string.orgchart_unlink_company: StringResource by lazy {
      StringResource("string:orgchart_unlink_company", "orgchart_unlink_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59673, 59),
      ))
    }

@delegate:ResourceContentHash(-1_411_927_226)
internal val Res.string.orgchart_unlink_company_msg: StringResource by lazy {
      StringResource("string:orgchart_unlink_company_msg", "orgchart_unlink_company_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59533, 139),
      ))
    }

@delegate:ResourceContentHash(239_141_409)
internal val Res.string.orgchart_unlink_director: StringResource by lazy {
      StringResource("string:orgchart_unlink_director", "orgchart_unlink_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59862, 60),
      ))
    }

@delegate:ResourceContentHash(337_365_610)
internal val Res.string.orgchart_unlink_director_msg: StringResource by lazy {
      StringResource("string:orgchart_unlink_director_msg", "orgchart_unlink_director_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59733, 128),
      ))
    }

@delegate:ResourceContentHash(239_141_409)
internal val Res.string.orgchart_unlink_manager: StringResource by lazy {
      StringResource("string:orgchart_unlink_manager", "orgchart_unlink_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60055, 59),
      ))
    }

@delegate:ResourceContentHash(-1_745_213_455)
internal val Res.string.orgchart_unlink_manager_msg: StringResource by lazy {
      StringResource("string:orgchart_unlink_manager_msg", "orgchart_unlink_manager_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59923, 131),
      ))
    }

@delegate:ResourceContentHash(-1_333_520_925)
internal val Res.string.orgchart_version_current_suffix: StringResource by lazy {
      StringResource("string:orgchart_version_current_suffix", "orgchart_version_current_suffix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60115, 51),
      ))
    }

@delegate:ResourceContentHash(-345_711_948)
internal val Res.string.orgchart_version_info: StringResource by lazy {
      StringResource("string:orgchart_version_info", "orgchart_version_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60167, 61),
      ))
    }

@delegate:ResourceContentHash(-645_787_693)
internal val Res.string.orgchart_versions_title: StringResource by lazy {
      StringResource("string:orgchart_versions_title", "orgchart_versions_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60229, 63),
      ))
    }

@delegate:ResourceContentHash(-1_199_343_271)
internal val Res.string.orgchart_without_director: StringResource by lazy {
      StringResource("string:orgchart_without_director", "orgchart_without_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60293, 53),
      ))
    }

@delegate:ResourceContentHash(-1_276_654_650)
internal val Res.string.pagination_next: StringResource by lazy {
      StringResource("string:pagination_next", "pagination_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60347, 47),
      ))
    }

@delegate:ResourceContentHash(-600_578_096)
internal val Res.string.pagination_previous: StringResource by lazy {
      StringResource("string:pagination_previous", "pagination_previous", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60395, 51),
      ))
    }

@delegate:ResourceContentHash(-2_014_306_644)
internal val Res.string.permission_auditoria: StringResource by lazy {
      StringResource("string:permission_auditoria", "permission_auditoria", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60447, 60),
      ))
    }

@delegate:ResourceContentHash(1_098_986_960)
internal val Res.string.permission_companies: StringResource by lazy {
      StringResource("string:permission_companies", "permission_companies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60508, 60),
      ))
    }

@delegate:ResourceContentHash(-402_441_773)
internal val Res.string.permission_comunicados: StringResource by lazy {
      StringResource("string:permission_comunicados", "permission_comunicados", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60569, 46),
      ))
    }

@delegate:ResourceContentHash(1_171_252_138)
internal val Res.string.permission_organograma: StringResource by lazy {
      StringResource("string:permission_organograma", "permission_organograma", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60616, 46),
      ))
    }

@delegate:ResourceContentHash(534_635_032)
internal val Res.string.permission_saude_do_sistema: StringResource by lazy {
      StringResource("string:permission_saude_do_sistema", "permission_saude_do_sistema", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60663, 59),
      ))
    }

@delegate:ResourceContentHash(712_903_690)
internal val Res.string.permission_usuarios: StringResource by lazy {
      StringResource("string:permission_usuarios", "permission_usuarios", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60723, 59),
      ))
    }

@delegate:ResourceContentHash(-747_396_985)
internal val Res.string.privacy_back: StringResource by lazy {
      StringResource("string:privacy_back", "privacy_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60783, 28),
      ))
    }

@delegate:ResourceContentHash(1_604_361_218)
internal val Res.string.privacy_s10_body: StringResource by lazy {
      StringResource("string:privacy_s10_body", "privacy_s10_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60812, 692),
      ))
    }

@delegate:ResourceContentHash(913_432_335)
internal val Res.string.privacy_s10_title: StringResource by lazy {
      StringResource("string:privacy_s10_title", "privacy_s10_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61505, 61),
      ))
    }

@delegate:ResourceContentHash(1_748_470_922)
internal val Res.string.privacy_s11_body: StringResource by lazy {
      StringResource("string:privacy_s11_body", "privacy_s11_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61567, 1328),
      ))
    }

@delegate:ResourceContentHash(-1_837_851_144)
internal val Res.string.privacy_s11_title: StringResource by lazy {
      StringResource("string:privacy_s11_title", "privacy_s11_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62896, 53),
      ))
    }

@delegate:ResourceContentHash(-2_049_225_344)
internal val Res.string.privacy_s12_body: StringResource by lazy {
      StringResource("string:privacy_s12_body", "privacy_s12_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62950, 440),
      ))
    }

@delegate:ResourceContentHash(1_503_058_374)
internal val Res.string.privacy_s12_title: StringResource by lazy {
      StringResource("string:privacy_s12_title", "privacy_s12_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63391, 53),
      ))
    }

@delegate:ResourceContentHash(1_340_082_126)
internal val Res.string.privacy_s13_body: StringResource by lazy {
      StringResource("string:privacy_s13_body", "privacy_s13_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63445, 540),
      ))
    }

@delegate:ResourceContentHash(619_509_174)
internal val Res.string.privacy_s13_title: StringResource by lazy {
      StringResource("string:privacy_s13_title", "privacy_s13_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63986, 69),
      ))
    }

@delegate:ResourceContentHash(-1_674_836_507)
internal val Res.string.privacy_s14_body: StringResource by lazy {
      StringResource("string:privacy_s14_body", "privacy_s14_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64056, 472),
      ))
    }

@delegate:ResourceContentHash(384_264_787)
internal val Res.string.privacy_s14_title: StringResource by lazy {
      StringResource("string:privacy_s14_title", "privacy_s14_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64529, 69),
      ))
    }

@delegate:ResourceContentHash(1_448_401_139)
internal val Res.string.privacy_s15_body: StringResource by lazy {
      StringResource("string:privacy_s15_body", "privacy_s15_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64599, 368),
      ))
    }

@delegate:ResourceContentHash(663_351_205)
internal val Res.string.privacy_s15_title: StringResource by lazy {
      StringResource("string:privacy_s15_title", "privacy_s15_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64968, 57),
      ))
    }

@delegate:ResourceContentHash(1_626_691_887)
internal val Res.string.privacy_s16_body: StringResource by lazy {
      StringResource("string:privacy_s16_body", "privacy_s16_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65026, 372),
      ))
    }

@delegate:ResourceContentHash(-654_986_474)
internal val Res.string.privacy_s16_title: StringResource by lazy {
      StringResource("string:privacy_s16_title", "privacy_s16_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65399, 65),
      ))
    }

@delegate:ResourceContentHash(-2_128_595_507)
internal val Res.string.privacy_s17_body: StringResource by lazy {
      StringResource("string:privacy_s17_body", "privacy_s17_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65465, 432),
      ))
    }

@delegate:ResourceContentHash(-1_211_455_851)
internal val Res.string.privacy_s17_title: StringResource by lazy {
      StringResource("string:privacy_s17_title", "privacy_s17_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65898, 61),
      ))
    }

@delegate:ResourceContentHash(1_029_066_329)
internal val Res.string.privacy_s18_body: StringResource by lazy {
      StringResource("string:privacy_s18_body", "privacy_s18_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65960, 420),
      ))
    }

@delegate:ResourceContentHash(-572_043_486)
internal val Res.string.privacy_s18_title: StringResource by lazy {
      StringResource("string:privacy_s18_title", "privacy_s18_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66381, 65),
      ))
    }

@delegate:ResourceContentHash(-286_539_047)
internal val Res.string.privacy_s1_body: StringResource by lazy {
      StringResource("string:privacy_s1_body", "privacy_s1_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66447, 467),
      ))
    }

@delegate:ResourceContentHash(-841_021_855)
internal val Res.string.privacy_s1_title: StringResource by lazy {
      StringResource("string:privacy_s1_title", "privacy_s1_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66915, 52),
      ))
    }

@delegate:ResourceContentHash(-1_819_663_801)
internal val Res.string.privacy_s2_body: StringResource by lazy {
      StringResource("string:privacy_s2_body", "privacy_s2_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66968, 1351),
      ))
    }

@delegate:ResourceContentHash(-1_270_127_679)
internal val Res.string.privacy_s2_title: StringResource by lazy {
      StringResource("string:privacy_s2_title", "privacy_s2_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68320, 40),
      ))
    }

@delegate:ResourceContentHash(-1_612_419_459)
internal val Res.string.privacy_s3_body: StringResource by lazy {
      StringResource("string:privacy_s3_body", "privacy_s3_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68361, 543),
      ))
    }

@delegate:ResourceContentHash(797_142_768)
internal val Res.string.privacy_s3_title: StringResource by lazy {
      StringResource("string:privacy_s3_title", "privacy_s3_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68905, 56),
      ))
    }

@delegate:ResourceContentHash(-1_169_524_477)
internal val Res.string.privacy_s4_body: StringResource by lazy {
      StringResource("string:privacy_s4_body", "privacy_s4_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68962, 1019),
      ))
    }

@delegate:ResourceContentHash(1_968_270_471)
internal val Res.string.privacy_s4_title: StringResource by lazy {
      StringResource("string:privacy_s4_title", "privacy_s4_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69982, 56),
      ))
    }

@delegate:ResourceContentHash(1_855_468_679)
internal val Res.string.privacy_s5_body: StringResource by lazy {
      StringResource("string:privacy_s5_body", "privacy_s5_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70039, 667),
      ))
    }

@delegate:ResourceContentHash(-1_052_334_912)
internal val Res.string.privacy_s5_title: StringResource by lazy {
      StringResource("string:privacy_s5_title", "privacy_s5_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70707, 60),
      ))
    }

@delegate:ResourceContentHash(-1_418_678_146)
internal val Res.string.privacy_s6_body: StringResource by lazy {
      StringResource("string:privacy_s6_body", "privacy_s6_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70768, 699),
      ))
    }

@delegate:ResourceContentHash(476_132_881)
internal val Res.string.privacy_s6_title: StringResource by lazy {
      StringResource("string:privacy_s6_title", "privacy_s6_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71468, 40),
      ))
    }

@delegate:ResourceContentHash(1_770_100_244)
internal val Res.string.privacy_s7_body: StringResource by lazy {
      StringResource("string:privacy_s7_body", "privacy_s7_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71509, 575),
      ))
    }

@delegate:ResourceContentHash(-659_116_415)
internal val Res.string.privacy_s7_title: StringResource by lazy {
      StringResource("string:privacy_s7_title", "privacy_s7_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72085, 60),
      ))
    }

@delegate:ResourceContentHash(-1_271_909_853)
internal val Res.string.privacy_s8_body: StringResource by lazy {
      StringResource("string:privacy_s8_body", "privacy_s8_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72146, 403),
      ))
    }

@delegate:ResourceContentHash(-355_417_354)
internal val Res.string.privacy_s8_title: StringResource by lazy {
      StringResource("string:privacy_s8_title", "privacy_s8_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72550, 64),
      ))
    }

@delegate:ResourceContentHash(1_274_419_662)
internal val Res.string.privacy_s9_body: StringResource by lazy {
      StringResource("string:privacy_s9_body", "privacy_s9_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72615, 491),
      ))
    }

@delegate:ResourceContentHash(2_005_870_182)
internal val Res.string.privacy_s9_title: StringResource by lazy {
      StringResource("string:privacy_s9_title", "privacy_s9_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73107, 60),
      ))
    }

@delegate:ResourceContentHash(214_863_867)
internal val Res.string.privacy_title: StringResource by lazy {
      StringResource("string:privacy_title", "privacy_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73168, 53),
      ))
    }

@delegate:ResourceContentHash(1_079_450_432)
internal val Res.string.privacy_updated_at: StringResource by lazy {
      StringResource("string:privacy_updated_at", "privacy_updated_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73222, 78),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.rh_action_cancel: StringResource by lazy {
      StringResource("string:rh_action_cancel", "rh_action_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73301, 36),
      ))
    }

@delegate:ResourceContentHash(2_027_828_074)
internal val Res.string.rh_action_delete: StringResource by lazy {
      StringResource("string:rh_action_delete", "rh_action_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73338, 52),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.rh_action_edit: StringResource by lazy {
      StringResource("string:rh_action_edit", "rh_action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73391, 30),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.rh_action_save: StringResource by lazy {
      StringResource("string:rh_action_save", "rh_action_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73422, 30),
      ))
    }

@delegate:ResourceContentHash(873_868_057)
internal val Res.string.rh_chart_absenteeism: StringResource by lazy {
      StringResource("string:rh_chart_absenteeism", "rh_chart_absenteeism", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73453, 60),
      ))
    }

@delegate:ResourceContentHash(-1_494_394_464)
internal val Res.string.rh_chart_active: StringResource by lazy {
      StringResource("string:rh_chart_active", "rh_chart_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73514, 51),
      ))
    }

@delegate:ResourceContentHash(-14_226_272)
internal val Res.string.rh_chart_movements: StringResource by lazy {
      StringResource("string:rh_chart_movements", "rh_chart_movements", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73566, 54),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString9Resources(map: MutableMap<String, StringResource>) {
  map.put("orgchart_save_draft", Res.string.orgchart_save_draft)
  map.put("orgchart_search_placeholder", Res.string.orgchart_search_placeholder)
  map.put("orgchart_select_placeholder", Res.string.orgchart_select_placeholder)
  map.put("orgchart_set_director", Res.string.orgchart_set_director)
  map.put("orgchart_set_responsible", Res.string.orgchart_set_responsible)
  map.put("orgchart_status_current", Res.string.orgchart_status_current)
  map.put("orgchart_status_draft", Res.string.orgchart_status_draft)
  map.put("orgchart_status_legacy", Res.string.orgchart_status_legacy)
  map.put("orgchart_subtitle_edited", Res.string.orgchart_subtitle_edited)
  map.put("orgchart_subtitle_published", Res.string.orgchart_subtitle_published)
  map.put("orgchart_subtitle_valid", Res.string.orgchart_subtitle_valid)
  map.put("orgchart_supervisor_available", Res.string.orgchart_supervisor_available)
  map.put("orgchart_supervisor_col_name", Res.string.orgchart_supervisor_col_name)
  map.put("orgchart_supervisor_col_role", Res.string.orgchart_supervisor_col_role)
  map.put("orgchart_supervisor_edit", Res.string.orgchart_supervisor_edit)
  map.put("orgchart_supervisor_empty", Res.string.orgchart_supervisor_empty)
  map.put("orgchart_supervisor_error", Res.string.orgchart_supervisor_error)
  map.put("orgchart_supervisor_none", Res.string.orgchart_supervisor_none)
  map.put("orgchart_supervisor_remove", Res.string.orgchart_supervisor_remove)
  map.put("orgchart_supervisor_saved", Res.string.orgchart_supervisor_saved)
  map.put("orgchart_supervisor_search", Res.string.orgchart_supervisor_search)
  map.put("orgchart_supervisor_selected", Res.string.orgchart_supervisor_selected)
  map.put("orgchart_title", Res.string.orgchart_title)
  map.put("orgchart_toast_draft_saved", Res.string.orgchart_toast_draft_saved)
  map.put("orgchart_toast_save_error", Res.string.orgchart_toast_save_error)
  map.put("orgchart_total_events", Res.string.orgchart_total_events)
  map.put("orgchart_total_stores", Res.string.orgchart_total_stores)
  map.put("orgchart_total_transported", Res.string.orgchart_total_transported)
  map.put("orgchart_total_upr", Res.string.orgchart_total_upr)
  map.put("orgchart_transfer_company", Res.string.orgchart_transfer_company)
  map.put("orgchart_transfer_manager", Res.string.orgchart_transfer_manager)
  map.put("orgchart_transfer_support", Res.string.orgchart_transfer_support)
  map.put("orgchart_transfer_to", Res.string.orgchart_transfer_to)
  map.put("orgchart_transfer_to_director", Res.string.orgchart_transfer_to_director)
  map.put("orgchart_unassigned_manager", Res.string.orgchart_unassigned_manager)
  map.put("orgchart_unlink_action", Res.string.orgchart_unlink_action)
  map.put("orgchart_unlink_company", Res.string.orgchart_unlink_company)
  map.put("orgchart_unlink_company_msg", Res.string.orgchart_unlink_company_msg)
  map.put("orgchart_unlink_director", Res.string.orgchart_unlink_director)
  map.put("orgchart_unlink_director_msg", Res.string.orgchart_unlink_director_msg)
  map.put("orgchart_unlink_manager", Res.string.orgchart_unlink_manager)
  map.put("orgchart_unlink_manager_msg", Res.string.orgchart_unlink_manager_msg)
  map.put("orgchart_version_current_suffix", Res.string.orgchart_version_current_suffix)
  map.put("orgchart_version_info", Res.string.orgchart_version_info)
  map.put("orgchart_versions_title", Res.string.orgchart_versions_title)
  map.put("orgchart_without_director", Res.string.orgchart_without_director)
  map.put("pagination_next", Res.string.pagination_next)
  map.put("pagination_previous", Res.string.pagination_previous)
  map.put("permission_auditoria", Res.string.permission_auditoria)
  map.put("permission_companies", Res.string.permission_companies)
  map.put("permission_comunicados", Res.string.permission_comunicados)
  map.put("permission_organograma", Res.string.permission_organograma)
  map.put("permission_saude_do_sistema", Res.string.permission_saude_do_sistema)
  map.put("permission_usuarios", Res.string.permission_usuarios)
  map.put("privacy_back", Res.string.privacy_back)
  map.put("privacy_s10_body", Res.string.privacy_s10_body)
  map.put("privacy_s10_title", Res.string.privacy_s10_title)
  map.put("privacy_s11_body", Res.string.privacy_s11_body)
  map.put("privacy_s11_title", Res.string.privacy_s11_title)
  map.put("privacy_s12_body", Res.string.privacy_s12_body)
  map.put("privacy_s12_title", Res.string.privacy_s12_title)
  map.put("privacy_s13_body", Res.string.privacy_s13_body)
  map.put("privacy_s13_title", Res.string.privacy_s13_title)
  map.put("privacy_s14_body", Res.string.privacy_s14_body)
  map.put("privacy_s14_title", Res.string.privacy_s14_title)
  map.put("privacy_s15_body", Res.string.privacy_s15_body)
  map.put("privacy_s15_title", Res.string.privacy_s15_title)
  map.put("privacy_s16_body", Res.string.privacy_s16_body)
  map.put("privacy_s16_title", Res.string.privacy_s16_title)
  map.put("privacy_s17_body", Res.string.privacy_s17_body)
  map.put("privacy_s17_title", Res.string.privacy_s17_title)
  map.put("privacy_s18_body", Res.string.privacy_s18_body)
  map.put("privacy_s18_title", Res.string.privacy_s18_title)
  map.put("privacy_s1_body", Res.string.privacy_s1_body)
  map.put("privacy_s1_title", Res.string.privacy_s1_title)
  map.put("privacy_s2_body", Res.string.privacy_s2_body)
  map.put("privacy_s2_title", Res.string.privacy_s2_title)
  map.put("privacy_s3_body", Res.string.privacy_s3_body)
  map.put("privacy_s3_title", Res.string.privacy_s3_title)
  map.put("privacy_s4_body", Res.string.privacy_s4_body)
  map.put("privacy_s4_title", Res.string.privacy_s4_title)
  map.put("privacy_s5_body", Res.string.privacy_s5_body)
  map.put("privacy_s5_title", Res.string.privacy_s5_title)
  map.put("privacy_s6_body", Res.string.privacy_s6_body)
  map.put("privacy_s6_title", Res.string.privacy_s6_title)
  map.put("privacy_s7_body", Res.string.privacy_s7_body)
  map.put("privacy_s7_title", Res.string.privacy_s7_title)
  map.put("privacy_s8_body", Res.string.privacy_s8_body)
  map.put("privacy_s8_title", Res.string.privacy_s8_title)
  map.put("privacy_s9_body", Res.string.privacy_s9_body)
  map.put("privacy_s9_title", Res.string.privacy_s9_title)
  map.put("privacy_title", Res.string.privacy_title)
  map.put("privacy_updated_at", Res.string.privacy_updated_at)
  map.put("rh_action_cancel", Res.string.rh_action_cancel)
  map.put("rh_action_delete", Res.string.rh_action_delete)
  map.put("rh_action_edit", Res.string.rh_action_edit)
  map.put("rh_action_save", Res.string.rh_action_save)
  map.put("rh_chart_absenteeism", Res.string.rh_chart_absenteeism)
  map.put("rh_chart_active", Res.string.rh_chart_active)
  map.put("rh_chart_movements", Res.string.rh_chart_movements)
}
